/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  MedicationStatementResponseDto,
  MedicationStatementUpsertRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MedicationStatementResponseDtoFromJSON,
    MedicationStatementResponseDtoToJSON,
    MedicationStatementUpsertRequestDtoFromJSON,
    MedicationStatementUpsertRequestDtoToJSON,
} from '../models/index';

export interface DeleteMedicationStatementRequest {
    medicationId: string;
}

export interface GetMedicationStatementsByPatientIdRequest {
    patientId: string;
}

export interface UpsertMedicationStatementRequest {
    medicationStatementUpsertRequestDto: MedicationStatementUpsertRequestDto;
}

/**
 * 
 */
export class PatientMedicationsApi extends runtime.BaseAPI {

    /**
     * Delete a medication statement
     */
    async deleteMedicationStatementRaw(requestParameters: DeleteMedicationStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['medicationId'] == null) {
            throw new runtime.RequiredError(
                'medicationId',
                'Required parameter "medicationId" was null or undefined when calling deleteMedicationStatement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements/{medicationId}`.replace(`{${"medicationId"}}`, encodeURIComponent(String(requestParameters['medicationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a medication statement
     */
    async deleteMedicationStatement(requestParameters: DeleteMedicationStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMedicationStatementRaw(requestParameters, initOverrides);
    }

    /**
     * Get current medication statements for a patient
     */
    async getMedicationStatementsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicationStatementResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicationStatementResponseDtoFromJSON));
    }

    /**
     * Get current medication statements for a patient
     */
    async getMedicationStatements(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicationStatementResponseDto>> {
        const response = await this.getMedicationStatementsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s medication statements by patient ID
     */
    async getMedicationStatementsByPatientIdRaw(requestParameters: GetMedicationStatementsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MedicationStatementResponseDto>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getMedicationStatementsByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicationStatementResponseDtoFromJSON));
    }

    /**
     * Get patient\'s medication statements by patient ID
     */
    async getMedicationStatementsByPatientId(requestParameters: GetMedicationStatementsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MedicationStatementResponseDto>> {
        const response = await this.getMedicationStatementsByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create or update a medication statement
     */
    async upsertMedicationStatementRaw(requestParameters: UpsertMedicationStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MedicationStatementResponseDto>> {
        if (requestParameters['medicationStatementUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'medicationStatementUpsertRequestDto',
                'Required parameter "medicationStatementUpsertRequestDto" was null or undefined when calling upsertMedicationStatement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/medication-statements`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MedicationStatementUpsertRequestDtoToJSON(requestParameters['medicationStatementUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MedicationStatementResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create or update a medication statement
     */
    async upsertMedicationStatement(requestParameters: UpsertMedicationStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MedicationStatementResponseDto> {
        const response = await this.upsertMedicationStatementRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
